import {
  Box,
  // Tabs,
  // TabList,
  // TabPanels,
  // TabPanel,
  Stack,
  HStack,
  Container,
} from "@chakra-ui/react";

import { useMemo } from "react";
import { useHistory } from "react-router-dom";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Tab from "components/Tab/Tab";
// import { CustomTab } from "../Cards/MyCard";

import WalletBalance from "components/WalletBalance/WalletBalance";
import FiatWalletActions from "components/WalletActions/FiatWalletActions";
import RecentTransactions from "components/RecentTransactions/RecentTransactions";
import { useGetWalletTransationsV2Query } from "services/walletApi";

import useWallet from "hooks/useWalletBalance";
import { toQueryString } from "util/utils";
import uniqBy from "lodash/uniqBy";

import selectCountryCurrency from "util/selectCountryCurrency";

// Panels
// import Fiat from "./Panels/Fiat";
// import Crypto from "./Panels/Crypto";

const Wallet = (props) => {
  const currentPage = "Wallet";
  const { userData } = props;

  const queries = toQueryString({
    // unit: ,
    limit: 7,
    sortBy: "createdAt:desc",
  });

  const history = useHistory();
  // const [tabIndex, setTabIndex] = useState(0);

  // const params = useMemo(
  //   () => new URLSearchParams(props?.location?.search),
  //   [props]
  // );

  const defaultUserCurrency = useMemo(
    () => selectCountryCurrency(userData?.country),
    [userData?.country]
  );

  // console.log("users currency", defaultUserCurrency);

  const { getCoin, isLoading, cryptos: _cryptos } = useWallet();

  const {
    data,
    isLoading: isTxLoading,
    // isFetching,
  } = useGetWalletTransationsV2Query(queries);

  const transactions = useMemo(() => data?.transactions, [data]);

  const cryptos = useMemo(
    () =>
      uniqBy(
        _cryptos.filter((crypto) => crypto?.coin !== "usdt-tron"),
        "coin"
      ),
    [_cryptos]
  );

  // console.log("PARAMS", params.toString());

  // useEffect(() => {
  //   const map = {
  //     fiat: 0,
  //     crypto: 1,
  //   };

  //   const index = map[params.get("tab")];
  //   console.log("TAB INDEX", index);
  //   setTabIndex(index);
  // }, [setTabIndex, params]);

  // const handleTabIndex = (index) => {
  //   setTabIndex(index);
  //   const map = {
  //     0: "fiat",
  //     1: "crypto",
  //   };
  //   params.set("tab", map[index]);

  //   history.push(`/dashboard/wallet?${params.toString()}`);
  // };

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="wallet">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <HStack
              w="100%"
              alignItems="flex-start"
              gridGap="20px"
              flexDir={["column", "column", "row"]}
            >
              <Box w={["100%", "100%", "50%"]}>
                <FiatWalletActions
                  minW="100%"
                  maxW="100%"
                  bg="linear-gradient(114.44deg, #027343 0%, #02AA63 100%)"
                  shadow="0px 2px 12px rgba(51, 31, 109, 0.18)"
                  isLoading={isLoading}
                  coin={defaultUserCurrency}
                  data={getCoin(defaultUserCurrency)}
                  userData={userData}
                />

                <Box
                  borderRadius="16px"
                  shadow="0px 8px 24px rgba(154, 170, 207, 0.15)"
                  bg="white"
                  p="28px"
                  mt="20px"
                  d={["none", "none", "block"]}
                >
                  <RecentTransactions
                    hasBorderBottom
                    isLoading={isTxLoading}
                    transactions={transactions}
                  />
                </Box>
              </Box>

              <Stack w={["100%", "100%", "50%"]} gap="20px">
                {!isLoading &&
                  cryptos?.map((crypto, i) => (
                    <WalletBalance
                      coin={crypto?.coin}
                      balance={crypto?.balance?.$numberDecimal}
                      onClick={() =>
                        history.push(`/dashboard/wallet/${crypto?.coin}`)
                      }
                      key={`crypto-wallet-balance-${i}`}
                    />
                  ))}
              </Stack>

              <Box
                borderRadius="16px"
                shadow="0px 8px 24px rgba(154, 170, 207, 0.15)"
                bg="white"
                p="28px"
                mt="20px"
                d={["block", "block", "none"]}
              >
                <RecentTransactions
                  hasBorderBottom
                  isLoading={isTxLoading}
                  transactions={transactions}
                />
              </Box>
            </HStack>
            {/* <Tabs
              variant="ghost"
              colorScheme="green"
              onChange={handleTabIndex}
              index={tabIndex}
              d={["none", "none", "block"]}
            >
              <TabList
                bg="white"
                borderRadius={[0, "8px"]}
                overflowX="overlay"
                sx={{
                  "::-webkit-scrollbar": {
                    h: "2px",
                  },
                }}
              >
                <Tab>Fiat</Tab>
                <Tab>Crypto</Tab>
              </TabList>

              <TabPanels>
                <TabPanel px="0">
                  <Fiat />
                </TabPanel>
                <TabPanel px="0">
                  <Crypto />
                </TabPanel>
              </TabPanels>
            </Tabs> */}

            {/* <Tabs
              w="100%"
              isFitted
              // mt="48px !important"
              d={["block", "block", "none"]}
              onChange={handleTabIndex}
              index={tabIndex}
            >
              <TabList border="none" borderRadius="6px" p="6px" bg="#D9DBE9">
                <CustomTab>Fiat</CustomTab>
                <CustomTab>Crypto</CustomTab>
              </TabList>

              <TabPanels>
                <TabPanel px="0">
                  <Fiat />
                </TabPanel>
                <TabPanel px="0">
                  <Crypto />
                </TabPanel>
              </TabPanels>
            </Tabs> */}
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default Wallet;
